import { Icon } from 'ant-design-vue';

export default Icon.createFromIconfontCN({
  // scriptUrl: "//at.alicdn.com/t/font_2540429_050i5bsgxjp1.js",
  scriptUrl: '//at.alicdn.com/t/c/font_2540429_0j6efsrai2z.js',
});
